import { api } from './api';

export interface CityPressure {
    cityId: string;
    supply: number;
    demand: number;
    pressure: string; // "1.25"
    maxWaitTime: number; // in seconds
}

export interface MarketplaceData {
    totalGlobalSupply: number; // Online Drivers
    totalGlobalDemand: number; // Waiting Rides
    totalOnlineRiders: number;
    pendingWithTip: number;
    activeSocketConnections: number;
    avgWaitTime: string; // "45.5"
    cityPressure: CityPressure[];
    ghostRate?: number;
    timestamp?: string;
    shardsProcessed?: number;
}

export interface VitalsData {
    overallStatus: 'HEALTHY' | 'DEGRADED';
    timestamp: string;
    nodeId: string;
    api: {
        uptime: number;
        eventLoopLagMs: number;
        memory: { heapUsed: string; rss: string };
        cpuLoad: string; // "0.45"
    };
    database: {
        status: string;
        latencyMs: number;
        geofencing: {
            isLoaded: boolean;
            count: number;
            cities: string[];
        };
    };
    redis: {
        status: string;
        memoryUsed: string;
        throughputOps: string;
        connectedClients: string;
    };
    marketplace: MarketplaceData;
    workers: {
        rideQueue: {
            waiting: number;
            active: number;
            completed: number;
            cancelled: number;
        };
        cleanupQueue: { waiting: number; active: number };
        subscriptionQueue: { waiting: number; active: number };
        isBacklogged: boolean;
    };
    telemetryMeta: {
        computeTimeMs: number;
        activeShards: number;
    };
}

// Response shape for the lightweight /marketplace endpoint
export interface MarketplaceSnapshotResponse {
    marketplace: MarketplaceData;
    timestamp: string;
    shardsProcessed: number;
}

/**
 * Fetches the full system vitals (Infrastructure + Aggregated Marketplace)
 */
export const getSystemVitals = () => api.get<VitalsData>('/admin/vitals');

/**
 * Fetches lightweight, high-frequency marketplace data only.
 * Returns the snapshot object created by the Backend Loop.
 */
export const getMarketplaceSnapshot = () => api.get<MarketplaceSnapshotResponse>('/admin/marketplace');